import { render, staticRenderFns } from "./IconNews.vue?vue&type=template&id=a7a51984&scoped=true&"
import script from "./IconNews.vue?vue&type=script&lang=js&"
export * from "./IconNews.vue?vue&type=script&lang=js&"
import style0 from "./IconNews.vue?vue&type=style&index=0&id=a7a51984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a51984",
  null
  
)

export default component.exports